import React from "react";
import { Box, Flex, Heading, Text, SimpleGrid, Button } from "@chakra-ui/react";
import { motion } from "framer-motion";
import supplychain from "../assets/supplychain.jpg";

export default function SupplyChain() {
  const MotionBox = motion(Box);

  const scmProcess = [
    {
      title: "Strategic Sourcing & Vendor Selection",
      desc: "Identification and qualification of reliable suppliers and OEMs based on technical performance, commercial terms, track record, and compliance with project standards.",
    },
    {
      title: "Contract Negotiation Support",
      desc: "Assistance in drafting and negotiating procurement contracts that ensure favorable terms for pricing, delivery timelines, warranties, and after-sales support.",
    },
    {
      title: "Logistics Planning & Coordination",
      desc: "Management of shipping, customs clearance, and inland transportation to ensure seamless delivery of components to project sites—especially in remote or logistically challenging locations.",
    },
    {
      title: "Inventory & Material Tracking",
      desc: "Implementation of tracking systems for critical equipment and materials to ensure availability in line with construction schedules and avoid site delays.",
    },
    {
      title: "Risk Assessment & Mitigation",
      desc: "Identification of supply chain risks—including geopolitical issues, material shortages, and currency fluctuations—and development of mitigation strategies such as dual sourcing or buffer stocks.",
    },
    {
      title: "Sustainability & Compliance",
      desc: "Ensuring that sourcing practices align with ESG goals and comply with local and international standards.",
    },
  ];

  return (
    <Box>
      <Box bg="#F5FAF6" color="#305D24">
        {/* Hero Section */}
        <Box
          position="relative"
          shadow="xl"
          textAlign="center"
          overflow="hidden"
          minH={{ base: "300px", md: "300px" }}
        >
          {/* Background Image */}
          <Box
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            bgImage={`url(${supplychain})`}
            bgSize="cover"
            bgPosition="center"
            filter="brightness(0.6) blur(2px)"
            zIndex={0}
          />

          {/* Content */}
          <Box
            position="relative"
            zIndex={1}
            color="white"
            p={{ base: 10, md: 16 }}
          >
            <Heading
              fontSize={{ base: "3xl", md: "5xl" }}
              mb={4}
              textShadow="2px 2px 4px rgba(0,0,0,0.7)"
            >
              Supply Chain Management
            </Heading>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              mt={4}
              maxW="3xl"
              mx="auto"
              textShadow="1px 1px 3px rgba(0,0,0,0.6)"
              fontWeight="bold"
            >
              Efficient and resilient supply chain management is critical to the
              success of renewable energy projects. We provide end-to-end
              support that ensures timely procurement, cost optimization, and
              quality assurance across all project components.
            </Text>
            <Text
              mt={4}
              maxW="3xl"
              mx="auto"
              textShadow="1px 1px 3px rgba(0,0,0,0.6)"
              fontWeight="bold"
            >
              Our services minimize delays, reduce risks, and ensure the
              availability of high-quality materials and equipment for solar,
              wind, and hybrid energy projects.
            </Text>
          </Box>
        </Box>

        {/* Process Section */}
        <Box
          bg="white"
          rounded="2xl"
          shadow="xl"
          fontSize={{ base: "2xl", md: "5xl" }}
          p={{ base: 6, md: 12 }}
          mb={12}
        >
          <Heading textAlign="center" size="xl" mb={10} color="#305D24">
            Our Process
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
            {scmProcess.map((step, idx) => (
              <MotionBox
                key={idx}
                p={6}
                rounded="xl"
                shadow="md"
                bg="#E6F4EA"
                whileHover={{ scale: 1.03 }}
              >
                <Heading size="md" mb={3} color="#15803D">
                  {step.title}
                </Heading>
                <Text fontSize="sm">{step.desc}</Text>
              </MotionBox>
            ))}
          </SimpleGrid>
        </Box>

        {/* Call to Action */}
        <Flex justify="center" py={10}>
          <Button
            bg="#FBBF24"
            color="#065F46"
            size="lg"
            as="a"
            href="/contact"
            _hover={{ bg: "#F59E0B", transform: "scale(1.05)" }}
            shadow="xl"
            rounded="full"
          >
            Start a Project
          </Button>
        </Flex>
      </Box>
    </Box>
  );
}
